import {FaSearch} from 'react-icons/fa'
import {useHistory} from 'react-router-dom'
import InfoTitle from './InfoTitle'
import {useState} from 'react'

const Search = ({ /*setHideResVar, onChangeSearch, txtValue,searchRes,onClickRes,hideResVar,*/searchInputWidth,searchContWidth,searchHeight}) => {
    const history = useHistory()
    const [searchTitles, setSearchTitles] = useState([])
    const [dataStatus,setDataStatus] = useState("loading")
    const [searchTxt, setSearchTxt] = useState("")

    const onChangeValue = (e) => {
        e.preventDefault()
        setSearchTxt(e.target.value)
        //onChangeSearch(e.target.value)
        if(e.target.value === ""){
          setDataStatus('loading')
          setSearchTitles([])
        }else if (e.target.value === null){
          setDataStatus('loading')
          setSearchTitles([])
        }else{
          fetchTitle(e.target.value)
        }
    }

    const onClickRes = (value) => {
        setSearchTxt(value)
        setDataStatus('loading')
    }

    const onClickSearch = (e) =>{
        e.preventDefault()
        if(searchTxt === "" || searchTxt === null){
            console.log('no value')
        }else{
            history.push('/wiki/'+searchTxt)
        }
        setDataStatus('loading')
    }

    const fetchTitle = async (value) => {
        const endPoint = "https://en.wikipedia.org/w/api.php"
        const params = {
            "origin": "*",
            "action": "query",
            "prop" : "extracts",
            "list":"search",
            "srsearch": value,
            "format": "json"
        };

        const esc = encodeURIComponent
        const query = Object.keys(params).map(k => esc(k) + '=' +esc(params[k])).join('&')
        const url = endPoint + "?" + query

        try{
            setDataStatus('loading')
            const res = await fetch(url)
            const data = await res.json()
            if (data.length !== 0) {
                setSearchTitles([data])
                setDataStatus('complete')  
                console.log(searchTitles)
                console.log(dataStatus)
            }else{
                setDataStatus('no result')
            }
            
                    
        }catch(err){
            console.log(err)
            setSearchTitles([])
            setDataStatus('error')
        }
        
      }

    return (
        <div style={{maxWidth: searchContWidth}} className="search-cont">
            <input style={{maxWidth: searchInputWidth, height: searchHeight}} autoComplete="off" value={searchTxt} onChange={onChangeValue}  type="text" name="searchInput" className="search-input" placeholder="Search"/>    
            <button style={{height: searchHeight}} onClick={onClickSearch} className="search-btn">
                <FaSearch size={15} color={'white'}/>
            </button>
            <br></br>
            {
                dataStatus === 'complete' &&
                <div className="search-results-cont">
                    {   
                        searchTitles[0].query.search.map((info, index) => (
                            <InfoTitle onClickTitle={onClickRes} key={index} infoValue={info.title}/>
                        ))
                         
                    }
                </div>
                
            }
        </div>
    )
}

export default Search
